import { __require as requireForEach } from './forEach.js';

var each;
var hasRequiredEach;

function requireEach () {
	if (hasRequiredEach) return each;
	hasRequiredEach = 1;
	each = requireForEach();
	return each;
}

export { requireEach as __require };
//# sourceMappingURL=each.js.map
